import { Component } from '@angular/core';

@Component({
  selector: 'craft-porlal-help-menu',
  templateUrl: './porlal-help-menu.component.html',
  styleUrls: ['./porlal-help-menu.component.scss'],
  standalone: false,
})
export class PorlalHelpMenuComponent {
  constructor() {}

  public openIntercom() {}
}
